import type { ReactNode } from "react";
import { Link } from "react-router";
import { BrandMark } from "./BrandMark";

type AuthShellProps = {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="flex min-h-[100dvh] flex-col justify-center bg-[var(--color-paper)] py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="mb-6 flex justify-center">
          <BrandMark variant="dark" className="text-[1.35rem]" endorseHref="https://timetosizzle.com" />
        </div>
        <h1 className="text-center text-2xl font-extrabold tracking-tight text-[var(--color-ink)]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-center text-[0.95rem] text-[var(--color-ash)]">{subtitle}</p>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="rounded-[var(--radius-lg)] border border-[var(--color-hairline)] bg-white px-4 py-8 shadow-[var(--shadow-1)] sm:px-10">
          {children}
        </div>
        {footer && <div className="mt-6 text-center text-sm text-[var(--color-ash)]">{footer}</div>}
        <p className="mt-4 text-center text-sm text-[var(--color-ash)]">
          <Link to="/" className="font-semibold text-[var(--accent-dark)] no-underline hover:underline">
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
